import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

const StyledTextField = styled(TextField, {
})(({ theme }) => ({
  "& label": {
    color: theme.palette["black_solid"]["70"],
    left: "-6px",
    fontSize: theme.typography["body1"]["fontSize"],
    marginTop: "-5px"
  },
  "& legend": {
    marginLeft: "-3px"
  },
  "& label.Mui-focused": {
    color: theme.palette["primary"]["60"],
  },
  "& label.Mui-error": {
    color: theme.palette["error"]["60"]
  },
  "& label.Mui-disabled": {
    color: theme.palette["black_opacity"]["70"]
  },
  "& .MuiInputLabel-shrink": {
    marginTop: "0px"
  },
  "& .MuiOutlinedInput-root": {
    fontSize: theme.typography["body1"]["fontSize"],
    fontWeight: "body1.fontWeight",
    backgroundColor: theme.palette["white_opacity"]["100"],
    color: theme.palette["black_opacity"]["100"],
    "& fieldset": {
      borderColor: theme.palette["black_opacity"]["30"],
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette["primary"]["60"],
    },
    "&.Mui-error fieldset": {
      borderColor: theme.palette["error"]["60"],
    },
    "&.Mui-disabled fieldset": {
      backgroundColor: theme.palette["black_opacity"]["05"],
      borderColor: theme.palette["black_opacity"]["30"],
    }
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette["black_opacity"]["70"]
  }
}));

export default StyledTextField;